module.exports = __webpack_public_path__ + "img/photo_filter.4ed563db.svg";